import { render } from "./TrsxnsLoaderListItemView.vue?vue&type=template&id=452d3072"
import script from "./TrsxnsLoaderListItemView.vue?vue&type=script&lang=js"
export * from "./TrsxnsLoaderListItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__